
import LotterySignListComponent from "../../../components/lottery_signs/Index.vue";

export default {
  components: {
    LotterySignListComponent
  }
}
